import { render } from "./BaseFlatPickr.vue?vue&type=template&id=7cd2aaf2"
import script from "./BaseFlatPickr.vue?vue&type=script&lang=js"
export * from "./BaseFlatPickr.vue?vue&type=script&lang=js"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__